<template>
  <div class="mt-2">
    <v-alert type="warning" dense text>
      <p class="mb-0">
        <b class="font-weight-bold">Importante:</b> Alguns valores contratuais
        só serão incluídos neste relatório após a consolidação dos dados, o
        cálculo pela equipe financeira ou o fechamento do evento.
      </p>
      <small>
        Em caso de dúvidas, por favor, entre em
        <a @click.stop="$root.$emit('open-support-dialog')"
          >contato com o financeiro</a
        >
        para mais informações.
      </small>
    </v-alert>

    <div class="d-flex flex-column gap-3">
      <!-- Resume -->
      <!-- <v-card outlined rounded="lg">
          <v-card-text
            class="d-flex flex-wrap justify-space-around align-center"
          >
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingPayments"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{ reducedPayments.totalAmount | currency }}
              </h6>
              <span class="text-caption">Receita de vendas bruta</span>
            </div>
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingPayments"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{ -reducedPayments.totalPlatformFee | currency }}
              </h6>
              <span class="text-caption">Taxas da plataforma</span>
            </div>
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingPayments"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{
                  (reducedPayments.totalAmount -
                    reducedPayments.totalPlatformFee)
                    | currency
                }}
              </h6>

              <span class="text-caption">Total líquido de vendas </span>
            </div>
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingResourceRequests"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{ -reducedResourceRequests.totalPartyTotalDebit | currency }}
              </h6>

              <span class="text-caption">Solicitações de recursos</span>
            </div>
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingAdjustments"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{ reducedAdjustments | currency }}
              </h6>

              <span class="text-caption">Ajustes</span>
            </div>
            <div class="text-center d-flex flex-column align-center px-4">
              <v-skeleton-loader
                v-if="loadingWithdrawals"
                width="50"
                height="20"
                class="mb-1"
                type="card"
              />
              <h6 v-else class="mb-0">
                {{
                  -(reducedWithdrawals.paid + reducedWithdrawals.pending)
                    | currency
                }}
              </h6>
              <span class="text-caption">Repasses</span>
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="text-center d-flex flex-column align-center px-4"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-skeleton-loader
                    v-if="
                      loadingWithdrawals ||
                      loadingPayments ||
                      loadingResourceRequests ||
                      loadingAdjustments
                    "
                    width="50"
                    height="20"
                    class="mb-1"
                    type="card"
                  />
                  <h6
                    v-else
                    class="mb-0"
                    :class="total >= 0 ? 'success--text' : 'error--text'"
                  >
                    {{ total | currency }}
                  </h6>

                  <span class="text-caption">Saldo</span>
                </div>
              </template>
              <span>
                O saldo é calculado a partir de todos os pagamentos recebidos<br>
                via plataforma, ajustes, solicitações de recursos e repasses.
              </span>
            </v-tooltip>
          </v-card-text>
        </v-card> -->

      <!-- Payments -->
      <!-- <v-card outlined rounded="lg" :loading="loadingPayments">
          <div class="pa-3">
            <div class="d-flex justify-space-between mb-2">
              <h6 class="mb-0">Pagamentos</h6>
              <v-btn
                @click="loadPayments"
                :disabled="loadingPayments"
                icon
                small
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
            <v-alert v-if="errorPayments" type="error" class="mb-0">
              {{ errorPayments }}
            </v-alert>
            <v-alert
              v-if="!payments.length && !loadingPayments"
              type="info"
              class="mb-0"
              text
            >
              Nenhum pagamento registrado
            </v-alert>
            <template v-else>
              <v-alert
                v-if="reducedPayments.hasNotTaxedPayment"
                type="warning"
                class="mb-0"
              >
                Atenção: Há pagamentos que não foram taxados. Consulte a aba
                "Pagamentos" para ver mais detalhes.
              </v-alert>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">Método</th>
                    <th class="text-center">Quantidade</th>
                    <th class="text-right">Valor Bruto</th>
                    <th class="text-right">Taxa</th>
                    <th class="text-right">Valor Líquido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in reducedPayments.items"
                    :key="item.paymentMethod"
                  >
                    <td>
                      {{ PAYMENT.paymentMethod[item.paymentMethod].text }}
                    </td>
                    <td class="text-center">{{ item.count }}</td>
                    <td class="text-right">{{ item.amount | currency }}</td>
                    <td
                      class="text-right"
                      :class="item.platformFee > 0 ? 'error--text' : ''"
                    >
                      {{ (item.platformFee * -1) | currency }}
                    </td>
                    <td
                      class="text-right"
                      :class="
                        item.amount - item.platformFee > 0
                          ? 'blue--text'
                          : ''
                      "
                    >
                      {{ (item.amount - item.platformFee) | currency }}
                    </td>
                  </tr>
                </tbody>
                <td colspan="5">
                  <v-divider />
                  <v-divider />
                </td>
                <tfoot>
                  <tr class="font-weight-bold">
                    <td colspan="2">Total</td>
                    <td class="text-right">
                      {{ reducedPayments.totalAmount | currency }}
                    </td>
                    <td class="text-right error--text">
                      {{ (reducedPayments.totalPlatformFee * -1) | currency }}
                    </td>
                    <td class="text-right blue--text">
                      {{
                        (reducedPayments.totalAmount -
                          reducedPayments.totalPlatformFee)
                          | currency
                      }}
                    </td>
                  </tr>
                </tfoot>
              </v-simple-table>
            </template>
          </div>
        </v-card> -->

      <!-- Resource Requests -->
      <!-- <v-card outlined rounded="lg" :loading="loadingResourceRequests">
          <div class="pa-3">
            <div class="d-flex justify-space-between mb-2">
              <h6 class="mb-0">Solicitações de Recursos</h6>
              <v-btn
                @click="loadResourceRequests"
                :disabled="loadingResourceRequests"
                icon
                small
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
            <v-alert v-if="errorResourceRequests" type="error" class="mb-0">
              {{ errorResourceRequests }}
            </v-alert>
            <v-alert
              v-else-if="!resourceRequests.length && !loadingResourceRequests"
              type="info"
              text
              class="mb-0"
            >
              Nenhuma solicitação de recurso encontrada
            </v-alert>
            <v-simple-table v-else dense>
              <thead>
                <tr>
                  <th class="text-left">Codigo</th>
                  <th class="text-left">Itens</th>
                  <th class="text-right">Valor para evento</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in reducedResourceRequests.items"
                  :key="item.id"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.name }}</td>
                  <td
                    class="text-right"
                    :class="item.partyTotalDebit > 0 ? 'error--text' : ''"
                  >
                    {{ (item.partyTotalDebit * -1) | currency }}
                  </td>
                </tr>
              </tbody>
              <td colspan="4">
                <v-divider />
                <v-divider />
              </td>
              <tfoot>
                <tr class="font-weight-bold">
                  <td colspan="2">Total</td>
                  <td class="text-right error--text">
                    {{
                      (reducedResourceRequests.totalPartyTotalDebit * -1)
                        | currency
                    }}
                  </td>
                </tr>
              </tfoot>
            </v-simple-table>
          </div>
        </v-card> -->

      <!-- Adjustments -->
      <v-card outlined rounded="lg" :loading="loadingAdjustments">
        <div class="pa-3">
          <div class="d-flex justify-space-between mb-2 gap-2">
            <h6 class="mb-0">Ajustes</h6>
            <v-spacer />
            <v-btn
              @click="loadAdjustments"
              :disabled="loadingAdjustments"
              icon
              small
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </div>
          <v-alert v-if="errorAdjustments" type="error" class="mb-0">
            {{ errorAdjustments }}
          </v-alert>
          <v-alert
            v-else-if="!adjustments.length && !loadingAdjustments"
            type="info"
            class="mb-0"
            text
          >
            Nenhum ajuste registrado
          </v-alert>
          <v-simple-table v-else dense>
            <thead>
              <tr>
                <th class="text-left">Data</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Tipo</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in adjustments" :key="item.id">
                <td>{{ item.createdAt | date("DD/MM/YYYY HH:mm") }}</td>
                <td>{{ item.description }}</td>
                <td>{{ adjustmentsTypes[item.type] }}</td>
                <td
                  class="text-right"
                  :class="item.amount < 0 ? 'error--text' : 'blue--text'"
                >
                  {{ item.amount | currency }}
                </td>
              </tr>
            </tbody>
            <td colspan="4">
              <v-divider />
              <v-divider />
            </td>
            <tfoot>
              <tr class="font-weight-bold">
                <td colspan="3">Total</td>
                <td
                  class="text-right"
                  :class="
                    reducedAdjustments > 0
                      ? 'blue--text'
                      : reducedAdjustments < 0
                      ? 'error--text'
                      : ''
                  "
                >
                  {{ reducedAdjustments | currency }}
                </td>
              </tr>
            </tfoot>
          </v-simple-table>
        </div>
      </v-card>

      <!-- Withdrawals -->
      <v-card outlined rounded="lg" :loading="loadingWithdrawals">
        <div class="pa-3">
          <div class="d-flex justify-space-between mb-2 gap-2">
            <h6 class="mb-0">Repasses</h6>
            <v-spacer />
            <v-btn
              @click="loadWithdrawals"
              :disabled="loadingWithdrawals"
              icon
              small
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </div>
          <v-alert v-if="errorWithdrawals" type="error" class="mb-0">
            {{ errorWithdrawals }}
          </v-alert>
          <v-alert
            v-else-if="!withdrawals.length && !loadingWithdrawals"
            type="info"
            text
            class="mb-0"
          >
            Nenhum repasse registrado
          </v-alert>
          <v-simple-table v-else :loading="loadingWithdrawals" dense>
            <thead>
              <tr>
                <th class="text-left" style="min-width: 150px">Data</th>
                <th class="text-left" style="min-width: 300px; width: 100%">
                  Observação
                </th>
                <th class="text-center" style="width: 100px">Comprovante</th>
                <th class="text-center" style="width: 100px">Tipo</th>
                <th class="text-center" style="width: 100px">Status</th>
                <th class="text-right" style="width: 120px">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in withdrawals" :key="item.id">
                <td>{{ item.createdAt | date("DD/MM/YYYY HH:mm") }}</td>
                <td>
                  {{ item.observation }}
                </td>
                <td class="text-center">
                  <v-btn
                    v-if="item.proofDocument"
                    text
                    x-small
                    icon
                    :href="item.proofDocument"
                    target="_blank"
                  >
                    <v-icon small>mdi-file-download</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-tooltip top>
                    <template #activator="{ on, attrs }">
                      <v-alert
                        :color="withdrawalsTypes[item.type].color"
                        class="text-12 mb-0 px-2"
                        style="
                          padding: 3px 12px;
                          width: 100px;
                          text-align: center;
                        "
                        v-bind="attrs"
                        v-on="on"
                        text
                        dense
                        label
                      >
                        {{ withdrawalsTypes[item.type].text }}
                      </v-alert>
                    </template>
                    <span>
                      {{ withdrawalsTypes[item.type].description }}
                    </span>
                  </v-tooltip>
                </td>
                <td>
                  <v-chip
                    :color="withdrawalsStatuses[item.status].color"
                    small
                    label
                    style="width: 90px; text-align: center"
                    class="justify-center"
                  >
                    {{ withdrawalsStatuses[item.status].text }}
                  </v-chip>
                </td>
                <td
                  class="text-right"
                  :class="item.status === 'PAID' ? 'blue--text' : 'error--text'"
                >
                  {{ item.amount | currency }}
                </td>
              </tr>
            </tbody>
            <td colspan="6">
              <v-divider />
              <v-divider />
            </td>
            <tfoot>
              <template v-if="reducedWithdrawals.pending > 0">
                <tr style="font-style: italic; font-weight: medium">
                  <td colspan="5">Total pendente</td>
                  <td class="text-right">
                    {{ reducedWithdrawals.pending | currency }}
                  </td>
                </tr>
                <tr style="font-style: italic; font-weight: medium">
                  <td colspan="5">Total pago</td>
                  <td class="text-right">
                    {{ reducedWithdrawals.paid | currency }}
                  </td>
                </tr>
              </template>
              <tr class="font-weight-bold">
                <td colspan="5">Total</td>
                <td class="text-right">
                  {{
                    (reducedWithdrawals.paid + reducedWithdrawals.pending)
                      | currency
                  }}
                </td>
              </tr>
            </tfoot>
          </v-simple-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PAYMENT from "@/utils/payment";
import PARTY from "@/services/admin/party";
const PARTYREPORTS = PARTY.reports;

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    PAYMENT,

    // Payments
    payments: [],
    loadingPayments: true,
    errorPayments: null,

    // Resource Requests
    resourceRequests: [],
    loadingResourceRequests: true,
    errorResourceRequests: null,
    types: {
      EQUIPMENT: {
        id: "EQUIPMENT",
        name: "Equipamento",
        icon: "mdi-cog",
        description: "Negociação de equipamentos",
      },
      FOOD: {
        id: "FOOD",
        name: "Alimentação",
        icon: "mdi-food",
        description: "Alimentação",
      },
      FREIGHT: {
        id: "FREIGHT",
        name: "Envio",
        icon: "mdi-truck",
        description: "Envio de equipamentos",
      },
      HOSTING: {
        id: "HOSTING",
        name: "Hospedagem",
        icon: "mdi-home",
        description: "Hospedagem",
      },
      HUMAN_RESOURCE: {
        id: "HUMAN_RESOURCE",
        name: "Recursos Humanos",
        icon: "mdi-human",
        description: "Recursos Humanos",
      },
      TRANSPORT: {
        id: "TRANSPORT",
        name: "Transporte",
        icon: "mdi-car",
        description: "Transporte",
      },
    },

    // Withdrawals
    withdrawals: [],
    loadingWithdrawals: true,
    errorWithdrawals: null,
    withdrawalsTypes: {
      FULL: {
        text: "Total",
        color: "primary",
        description: "Repasse total do saldo no momento do pagamento",
      },
      PARTIAL: {
        text: "Parcial",
        color: "info",
        description: "Repasse parcial do saldo no momento do pagamento",
      },
      ADVANCE: {
        text: "Adiantamento",
        color: "warning",
        description: "Repasse maior que o saldo no momento do pagamento",
      },
    },
    withdrawalsStatuses: {
      PAID: {
        text: "Pago",
        color: "success",
      },
      PENDING: {
        text: "Pendente",
        color: "warning",
      },
      REJECTED: {
        text: "Rejeitado",
        color: "error",
      },
      CANCELLED: {
        text: "Cancelado",
        color: "secondary",
      },
    },

    // Adjustments
    adjustments: [],
    loadingAdjustments: true,
    errorAdjustments: null,
    adjustmentsTypes: {
      CASHBACK: "Cashback",
      REFUND: "Reembolso",
      DISCOUNT: "Desconto",
      BONUS: "Bônus",
      CREDIT: "Crédito",
      FEE: "Taxa",
      TAX: "Taxa",
      FINE: "Multa",
      DEBIT: "Débito",
      OTHER: "Outro",
    },
  }),
  methods: {
    ...mapActions("organization", ["partyById"]),
    async loadFullData() {
      // await this.getParty();
      await Promise.all([
        // this.loadPayments(),
        // this.loadResourceRequests(),
        this.loadWithdrawals(),
        this.loadAdjustments(),
      ]);
    },
    async getParty() {
      try {
        this.loading = true;
        this.payments = [];
        this.resourceRequests = [];
        this.withdrawals = [];
        this.adjustments = [];

        var response = await this.partyById(this.$route.params.partyId);
        this.party = response;
        this.loading = false;
      } catch (error) {
        this.$router.push({ name: "admin.parties" });
      }
    },
    async loadPayments() {
      try {
        this.loadingPayments = true;
        this.errorPayments = null;
        const response = await PARTYREPORTS.payments(
          this.selectedOrganization.id,
          this.party.id,
          { status: "succeeded" }
        );
        this.payments = response.payments;
      } catch (error) {
        this.errorPayments = error.message || error;
      } finally {
        this.loadingPayments = false;
      }
    },
    async loadResourceRequests() {
      try {
        this.loadingResourceRequests = true;
        this.errorResourceRequests = null;

        const response = await PARTY.financial.resourceRequests(
          this.selectedOrganization.id,
          this.party.id
        );
        this.resourceRequests = response.resourceRequests;
      } catch (error) {
        this.errorResourceRequests = error.message || error;
      } finally {
        this.loadingResourceRequests = false;
      }
    },
    async loadWithdrawals() {
      try {
        this.loadingWithdrawals = true;
        this.errorWithdrawals = null;

        const response = await PARTY.financial.withdrawals(
          this.selectedOrganization.id,
          this.party.id
        );
        this.withdrawals = response.withdrawals;
      } catch (error) {
        this.errorWithdrawals = error.message || error;
      } finally {
        this.loadingWithdrawals = false;
      }
    },
    async loadAdjustments() {
      try {
        this.loadingAdjustments = true;
        this.errorAdjustments = null;

        const response = await PARTY.financial.adjustments(
          this.selectedOrganization.id,
          this.party.id
        );
        this.adjustments = response.adjustments;
      } catch (error) {
        this.errorAdjustments = error.message || error;
      } finally {
        this.loadingAdjustments = false;
      }
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["hasPermission"]),
    reducedPayments() {
      let hasNotTaxedPayment = false;
      let totalAmount = 0;
      let totalPlatformFee = 0;
      const reduced = this.payments.reduce((acc, payment) => {
        // Hard filters
        if (payment.status !== "succeeded") return acc;
        if (payment.paymentType === "MONEY") return acc;

        // Soft filters
        let paymentMethod = payment.paymentMethod;
        if (payment.paymentType === "COURTESY") paymentMethod = "COURTESY";

        if (!acc[paymentMethod]) {
          acc[paymentMethod] = {
            paymentMethod,
            amount: 0,
            count: 0,
            platformFee: 0,
          };
        }

        acc[paymentMethod].count++;
        acc[paymentMethod].amount += payment.amount;
        acc[paymentMethod].platformFee += payment.platformFee;
        totalAmount += payment.amount;
        totalPlatformFee += payment.platformFee;
        if (
          paymentMethod !== "COURTESY" &&
          payment.paymentType !== "MONEY" &&
          payment.platformFee <= 0
        ) {
          hasNotTaxedPayment = true;
        }

        return acc;
      }, {});

      return {
        totalAmount,
        totalPlatformFee,
        hasNotTaxedPayment,
        items: Object.values(reduced),
      };
    },
    reducedResourceRequests() {
      let totalAmount = 0;
      let totalPartyTotalDebit = 0;
      const reduced = this.resourceRequests
        .filter((resourceRequest) =>
          ["APPROVED", "PAID"].includes(resourceRequest.status)
        )
        .map((resourceRequest) => {
          const amount = resourceRequest.items.reduce((acc, item) => {
            return acc + item.amount;
          }, 0);
          totalAmount += amount;
          totalPartyTotalDebit += resourceRequest.partyTotalDebit;
          return {
            ...resourceRequest,
            name: resourceRequest.items
              .map((item) => this.types[item.type].name)
              .join(", "),
            totalAmount: amount,
          };
        });

      return {
        totalAmount,
        totalPartyTotalDebit,
        items: reduced,
      };
    },
    reducedAdjustments() {
      return this.adjustments.reduce(
        (acc, adjustment) => acc + adjustment.amount,
        0
      );
    },
    reducedWithdrawals() {
      return this.withdrawals.reduce(
        (acc, withdrawal) => {
          const status = withdrawal.status.toLowerCase();
          if (acc[status] === undefined) acc[status] = 0;
          acc[status] += withdrawal.amount;
          return acc;
        },
        {
          pending: 0,
          paid: 0,
        }
      );
    },
    total() {
      return (
        this.reducedPayments.totalAmount -
        this.reducedPayments.totalPlatformFee -
        this.reducedResourceRequests.totalPartyTotalDebit +
        this.reducedAdjustments -
        this.reducedWithdrawals.paid -
        this.reducedWithdrawals.pending
      );
    },
  },
  watch: {
    "$route.params.partyId"() {
      this.loadFullData();
    },
    "selectedOrganization.id"() {
      this.$router.push({
        name: "admin.parties",
      });
    },
  },
  mounted() {
    this.loadFullData();
  },
};
</script>

<style></style>
